import { createPromiseClient } from "@apachedubbo/dubbo";
import { TriAirDatabaseService } from "@onetakesolutions/cargogo-contract-web/TriAirDatabaseService_dubbo";
import transport from "../transport";

const client = createPromiseClient(TriAirDatabaseService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
